.root {
  width: 100%;
}

.option {
  padding-right: var(--spacingMd);
}

.tableVariant {
  height: 100%;
}
